import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config";

const { image, video } = AssetFieldsConfig;
const { playWhenVisible, loop, ...videoOtherFields } = video.fields;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Scroll Parallax",
  fields: {
    paragraphs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Paragraphs",
      maxLimit: 3,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          title: {
            type: FIELD_TYPES.TEXT,
            label: "Title",
            translatable: true
          },
          description: {
            type: FIELD_TYPES.TEXT,
            label: "Description",
            translatable: true
          },
          avatarSrc: {
            type: FIELD_TYPES.GALLERY,
            label: "Avatar",
            defaultImagesKeys: []
          },
          testimonial: {
            type: FIELD_TYPES.TEXT,
            label: "Testimonial",
            translatable: true
          },
          name: {
            type: FIELD_TYPES.TEXT,
            label: "Name"
          },
          jobTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Job title",
            translatable: true
          },
          companyName: {
            type: FIELD_TYPES.TEXT,
            label: "Company name"
          }
        }
      }
    },
    topAsset: { ...image, label: "Top asset" },
    bottomAsset: { ...video, label: "Bottom asset", fields: videoOtherFields }
  }
};
